<template>
  <PageCatalog
    :init-catalog-scope="catalogScope"
    :init-catalog-state="catalogState"
    :init-page="page"
    :init-per-page="perPage"
    :init-products="products"
    :is-search="true"/>
</template>

<script>
import { chunk } from 'lodash'
import AppRouteMixin from '~/mixins/AppRouteMixin'
import PageCatalog from '@theme/components/product/PageCatalog'
import parseParams from '~/app/parseParams'

const PAGE = {
  name: 'RouteCatalog',
  nuxtI18n: {
    paths: {
      cs: '/hledat',
      de: '/suche',
      en: '/search',
      sk: '/hladat',
    },
  },
  middleware({ store }) {
    store.commit('locale/SET_ALTERNATIVE_PATHS', PAGE.nuxtI18n.paths)
  },
  components: {
    PageCatalog,
  },
  mixins: [AppRouteMixin],
  async asyncData({ query, store }) {
    const perPage = 21 // TODO: config
    const page = Number(query.p) > 0 ? Number(query.p) : 0
    const search = query.s || ''
    const location = 'catalog'
    await store.commit('search/SET_PER_PAGE', { location, perPage })
    await store.dispatch('search/CHANGE_QUERY', { location, query: search, page })
    const selected = [...(query.nf ? parseParams(query.nf) : [])]
    const selectedTags = query.tags ? query.tags.split('.') : null

    // Prepare scope for catalog
    const catalogScope = {
      params: [],
      search: search,
      selected,
      selectedTags,
      sort: query.sort ? query.sort : 'SearchSort',
      price: query.price ? query.price.split('-').map(p => (p ? Number(p) : null)) : null,
      stock: query.stock ? query.stock === '1' : false,
    }

    // Get catalog state given scope, active params from URL, etc.
    const catalogState = await store.dispatch('catalog/LOAD_CATALOG', { catalogScope }) // TODO: Add active params from URL

    // Load products for current page
    const products = store.dispatch('product/LOAD_PRODUCTS', {
      ids: chunk(catalogState.filteredIds, perPage)[page],
    })

    // Wait for all unfinished calls
    const data = {
      catalogState,
      catalogScope,
      page,
      perPage,
      products,
    }
    return await Promise.allValues(data)
  },
}
export default PAGE
</script>
